export const USERTYPE_NORMAL = 0
export const USERTYPE_ADMIN = 1
export const USERTYPE_TEST = 2

export const USERTYPE_NORMAL_STR = '普通用户'
export const USERTYPE_ADMIN_STR = '管理员'
export const USERTYPE_TEST_STR = '测试用户'


export const USERTYPE_STR_MAP = new Map([[USERTYPE_NORMAL_STR, USERTYPE_NORMAL], [USERTYPE_ADMIN_STR, USERTYPE_ADMIN], [USERTYPE_TEST_STR, USERTYPE_TEST]])

export const USERTYPE_INT_MAP = new Map([[USERTYPE_NORMAL, USERTYPE_NORMAL_STR], [USERTYPE_ADMIN, USERTYPE_ADMIN_STR], [USERTYPE_TEST, USERTYPE_TEST_STR]])